import React from 'react'
import { CommonSelect } from '@src/components'
import { EhrAppointmentKind } from '@src/types'
import { StyleService } from '@src/style/service'
import { VIDEO_CALL_DURATION_OPTIONS } from '../constants'

interface AppointmentDurationSelectProps {
  selectedAppointmentKind: EhrAppointmentKind
  handleSelectChange: (option: { value: EhrAppointmentKind }) => void
}

export const AppointmentDurationSelect = ({
  selectedAppointmentKind,
  handleSelectChange,
}: AppointmentDurationSelectProps) => {
  return (
    <CommonSelect
      selectedOption={VIDEO_CALL_DURATION_OPTIONS.find(
        (option) => option.value === selectedAppointmentKind,
      )}
      options={VIDEO_CALL_DURATION_OPTIONS}
      onSelect={handleSelectChange}
      appearance="rounded"
      size="small"
      style={styles.selectWrapper}
    />
  )
}

const styles = StyleService.create({
  selectWrapper: {
    minWidth: 107,
  },
})
